import styled from "@emotion/styled";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { colors } from "@zfp-akademie-a-s/zfp-design";
import { ChevronDownIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { PropsWithChildren } from "react";

type Props = {
  readonly onChange?: () => void;
};

const StyledAccordion = styled(Accordion)`
  ${({ theme }) => `
    padding: ${theme.spacing(Spacing.XL)};
    border: 1px solid ${colors.borderLight};
    border-radius: ${theme.spacing(Radius.M)} !important;
    box-shadow: ${theme.shadows[0]} !important;
  `}

  & .MuiAccordionSummary-content, & .MuiAccordionSummary-content .Mui-expanded {
    margin: 0 !important;
  }

  & .MuiAccordion-heading > .MuiButtonBase-root {
    min-height: 0;
    padding: 0;
  }

  & .MuiButtonBase-root.Mui-expanded {
    min-height: 0;
  }

  & .MuiAccordionDetails-root {
    padding: 0
  }
`;

export const ModelingAccordion: React.FC<PropsWithChildren<Props>> = ({ children, onChange }) => {
  const { t } = useResource();
  return (
    <StyledAccordion onChange={onChange}>
      <AccordionSummary expandIcon={<ChevronDownIcon sx={{ color: "text.secondary" }} />}>
        <Typography variant="subtitle1" fontWeight={500} lineHeight={1}>
          {t(Resources.AnalysisDetail.Goals.Modeling)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  );
};
